import React from "react";
import { Box, List, ListItem, Link } from "@mui/material";
import { useLocation } from "react-router-dom";

function NavBar() {
  const pathname = useLocation().pathname;

  const navigationItems = [
    {
      label: "Metrics",
      link: "/support",
    },
    {
      label: "Inbox",
      link: "/inbox-v2",
    },
    {
      label: "Social Posts",
      link: "/social-posts",
    },
  ];

  return (
    <Box sx={{ pt: 10 }}>
      <Box sx={styles.container}>
        <List sx={styles.listWrapper}>
          {navigationItems.map((item, index) => {
            const isActive = item.link === pathname;

            return (
              <ListItem key={index} sx={styles.listItem} disablePadding>
                <Link
                  sx={{
                    ...styles.navLink,
                    ...(isActive && {
                      ...styles.activeNavLink,
                    }),
                  }}
                  href={item.link}
                >
                  {item.label}
                </Link>
              </ListItem>
            );
          })}
        </List>
      </Box>
    </Box>
  );
}

export default NavBar;

const styles = {
  container: {
    backgroundColor: "#FFFFFF",
    px: "38px",
  },
  listWrapper: {
    display: "flex",
    alignItems: "center",
    padding: "0px",
    gap: "18px",
  },
  listItem: {
    width: "fit-content",
  },
  navLink: {
    fontFamily: "FustatSemiBold",
    color: "#003300",
    fontSize: "16px",
    textDecoration: "none",
    opacity: 0.5,
    padding: "12px 4px",
    borderBottom: "none",

    "&:hover": {
      textDecoration: "none",
      opacity: 1,
      color: "#003300",
    },
  },
  activeNavLink: {
    opacity: 1,
    borderBottom: "3px solid rgb(226, 103, 74)",
  },
};
